// extracted by mini-css-extract-plugin
export default {"root":"O7CDnxVWn4","mirror":"q9wazyrsoS","mirror_isBorderless":"ZM7RSIqLrj","mirror_hasNoPadding":"fdATv_VxFj","mirror_hasNoMinHeight":"O9Fpz4Q7TV","inputWrapper":"j7k1AmXTre"};